// extracted by mini-css-extract-plugin
export default {"legends":"TeethWidget_legends__anzsv"};